import { PRIVATE_EVENTS, EVENT_CALLBACK } from '../../handlers/EventManager/constants';
import { createDOMElement } from '../../helpers/fixtureUtils';
import StandingsService from '../../services/StandingsService';
import { ASSETS_IMAGES_BASE_URL } from '../../constants/AssetConstants';
import './index.scss';
import { JSON_IMAGE_BASE_URL } from '../../constants/FixtureConstants';

class StandingsWidget {
    constructor(sportsManager,standingsConfig) {
        this.standingsConfig = standingsConfig
        this.assetConfig = this.standingsConfig.assetConfig
        this.jsonConfig = this.standingsConfig.jsonManagerConfig
        this.sportsManager = sportsManager;
        if (!this.sportsManager) {
            throw new Error('Sports manager is required in standings view.');
        }
        this.eventManager = this.sportsManager.eventManager;
        if (!this.eventManager) {
            throw new Error('Event manager is required in standings view.');
        }
        this.parentDom = document.getElementById(this.assetConfig.parentId);
        if (!this.parentDom) {
            this.eventManager.broadcastPublicEvent(PUBLIC_EVENTS.SPORTS_MANAGER_ERROR, {
                errorCode: 'err_100',
                errorMessage: 'DOM element is required in standings view.',
            });
        }
        this.standingsData = null;
        this.FEData = this.assetConfig.FEData;
        this.sportId = this.assetConfig.sportId;
        this.tourId = this.assetConfig.tourId;
        this.widgetCallback = this.assetConfig.widgetCallback;
        this.handleViewAllCard = this.assetConfig.handleSatndingsViewAllCard;
        this.handleSetHref = this.assetConfig.handleSetHref;

        if(!this.sportId || !this.tourId) {
            this.eventManager.broadcastPublicEvent(PUBLIC_EVENTS.SPORTS_MANAGER_ERROR, {
                errorCode: 'err_100',
                errorMessage: 'Sports id and tournament is required in standings view.',
            });
        }
        this.subscribeToEvents();
    }
    subscribeToEvents() {
        this.eventManager.subscribeToEvents({
            eventType: EVENT_CALLBACK.PRIVATE_EVENTS,
            eventCallback: this.privateEventCallback.bind(this),
            senderName: 'STANDINGS_SERVICE',
        });
    }
    privateEventCallback(eventName, eventData) {
        switch (eventName) {
          case PRIVATE_EVENTS.STANDINGS_UPDATE: {
            this.standingsData = eventData?.standingWidgetData
            this.standingMetaData = eventData?.standingsMetaData;
            this.render()
            break;
          }
    
          default: {
            console.log('Uncaught event');
            break;
          }
        }
    }
    getStandingsData() {
        const standingsService = new StandingsService(this.sportsManager);
        standingsService.fetchStandingsData(PRIVATE_EVENTS.STANDINGS_UPDATE, this.sportId, this.tourId,"standings",this.jsonConfig);
      }
    createElement(parent, className, id, innerHTML) {
        const dom = {
            ele: "div",
            attributes: {
                class: className,
            },
            parent,
            innerHTML
        }
        const element = createDOMElement(dom);
        if (id) {
            this.elementStore[id] = element;
        }
        return element;
    }

    renderStandingRow(rowData,parentContainer,index) {
        const standingTeamPosition = rowData?.position_status == "Up" ? "teamUp" : rowData?.position_status == "No change" ? "teamNoChange" : "teamDown"
        const standingTeamCard = this.createElement(parentContainer, `standing-team-container-card ${standingTeamPosition}`);
        const standingTeamDescCard = this.createElement(standingTeamCard, "standing-desc-container-card");
        const teamNumber = this.createElement(standingTeamDescCard, "standing-team-number-container","",index);
        const teamArrow = document.createElement('img');
        teamArrow.setAttribute('class', 'standing-team-arrow-container');
        teamArrow.src = rowData?.position_status == "Up" ? `${ASSETS_IMAGES_BASE_URL}/Chevron_up.svg` : `${ASSETS_IMAGES_BASE_URL}/Chevron_down.svg`;
        standingTeamDescCard.appendChild(teamArrow);
        const logoOuterCont = document.createElement('a');
        logoOuterCont.setAttribute('class', "standing-team-logo-outer-wrapper");
        this.handleSetHref("SET_HREF", rowData?.team_metadata, (route, isHrefEnabled) => {
            logoOuterCont.href = route
            if(isHrefEnabled === false) {
                logoOuterCont.classList.add("disablePointer")
            } 
        });
        logoOuterCont.addEventListener("click",(e) => {
            e.stopPropagation();
        })
        standingTeamDescCard.appendChild(logoOuterCont);
        const teamLogo = document.createElement('img');
        teamLogo.setAttribute('class', 'standing-team-logo-container');

        let imageEndPoint = this.jsonConfig?.imageEndPoint ? this.jsonConfig?.imageEndPoint : JSON_IMAGE_BASE_URL;

        // teamLogo.src = "https://player-dev.sonyliv.com/platform/web/sportssdk/asset/country_flags/24.png";
        teamLogo.src = `${imageEndPoint}/${this.sportId}/${rowData.team_id}.png`;
        teamLogo.onerror = function (e) {
            teamLogo.src = `${ASSETS_IMAGES_BASE_URL}/counrty_flag_logo_fallback_image.svg`;
        }
        teamLogo.alt = rowData?.team_short_name;
        logoOuterCont.appendChild(teamLogo);
        
        // const teamLogo = this.createElement(standingTeamCard, "standing-team-logo-container");
        // const teamTitle = this.createElement(standingTeamDescCard, "standing-team-title-container","",rowData?.team_short_name);
        const teamTitle = document.createElement('a');
        teamTitle.setAttribute('class', "standing-team-title-container");
        this.handleSetHref("SET_HREF", rowData?.team_metadata, (route, isHrefEnabled) => {
            teamTitle.href = route
            if(isHrefEnabled === false) {
                teamTitle.classList.add("disablePointer")
            } 
        });
        teamTitle.addEventListener("click",(e) => {
            e.stopPropagation();
        })
        teamTitle.innerText = rowData?.team_short_name;
        standingTeamDescCard.appendChild(teamTitle);
        const teamCoverCont = this.createElement(standingTeamCard, "standing-team-cover-container","");
        const teamMtitle = this.createElement(teamCoverCont, "standing-team-title-text-container standing-team-Mtitle-container","",rowData?.played);
        const teamWtitle = this.createElement(teamCoverCont, "standing-team-title-text-container standing-team-Wtitle-container","",rowData?.wins);
        const teamDtitle = this.createElement(teamCoverCont, "standing-team-title-text-container standing-team-Dtitle-container","",rowData?.draws);
        const teamLtitle = this.createElement(teamCoverCont, "standing-team-title-text-container standing-team-Ltitle-container","",rowData?.lost);
        const teamPtstitle = this.createElement(teamCoverCont, "standing-team-title-text-container standing-team-pts-container","",rowData?.points);

    }

    renderStanding(standing,parentContainer, groupName) {
        const standingCard = this.createElement(parentContainer, "standing-container-card");
        const standingInnerCard = this.createElement(standingCard, "standing-container-inner-card");
        const standingCardTitleCont = this.createElement(standingInnerCard, "standing-title-container");
        const grouptitle = this.createElement(standingCardTitleCont, "standing-title-container-text","",groupName);
        const groupCoverCont = this.createElement(standingCardTitleCont, "standing-cover-container","");
        const groupMtitle = this.createElement(groupCoverCont, "standing-title-text-container standing-Mtitle-container","","M");
        const groupWtitle = this.createElement(groupCoverCont, "standing-title-text-container standing-Wtitle-container","","W");
        const groupDtitle = this.createElement(groupCoverCont, "standing-title-text-container standing-Dtitle-container","","D");
        const groupLtitle = this.createElement(groupCoverCont, "standing-title-text-container standing-Ltitle-container","","L");
        const groupPtstitle = this.createElement(groupCoverCont, "standing-title-text-container standing-pts-title-container","","Pts");
        standing.slice(0,4).map((rowData,index)=> {
            this.renderStandingRow(rowData,standingInnerCard,index+1)
        })
        standingCard?.addEventListener("click", () => { this.handleViewAllCard(this.standingMetaData) });

    }

    render() {
        if(this.parentDom && this.standingsData?.length > 0) {
            const numberOfCards = this.FEData?.metadata?.number_ofcard_displayed || 10;
            const standingContainer = this.createElement(this.parentDom, "standing-container");

            const leftArrowCont = document.createElement('div');
            leftArrowCont.setAttribute('id', 'standing-prev-arrow');
            standingContainer.appendChild(leftArrowCont);

            const standingContainerSlides = this.createElement(standingContainer, "standing-container-slides");
            if(this.standingsData?.length > numberOfCards) {
                this.standingsData.slice(0, numberOfCards).map((standing) => {
                    this.renderStanding(standing.teams.team,standingContainerSlides, standing?.name);
                });
            } else {
                this.standingsData.map((standing) => {
                    this.renderStanding(standing.teams.team,standingContainerSlides, standing?.name);
                });
            }
            // this.renderStanding(this.standingsData[0].teams.team,standingContainerSlides);
            const standingViewAllContainer = this.createElement(standingContainerSlides, "standing-container-card standing-view-all-container");
            const standingViewAllTxt = this.createElement(standingViewAllContainer, "standing-view-all-text","","View More");
            standingViewAllContainer?.addEventListener("click", () => { this.handleViewAllCard(this.standingMetaData) });

            const rigthArrowCont = document.createElement('div');
            rigthArrowCont.setAttribute('id', 'standing-next-arrow');
            standingContainer.appendChild(rigthArrowCont);

            rigthArrowCont.addEventListener('click', () => {
                standingContainerSlides.scrollLeft += standingContainerSlides.clientWidth / 1.5;
            });

            leftArrowCont.addEventListener('click', () => {
                standingContainerSlides.scrollLeft -= standingContainerSlides.clientWidth / 1.5;
            });

            standingContainerSlides.onscroll = (event) => {
                this.toggleArrows(standingContainerSlides, rigthArrowCont, leftArrowCont);
            };

            if(typeof this.widgetCallback == "function"){
                this.widgetCallback("STANDINGS_RENDER_SUCCESS", this.standingMetaData)
            }
            
            this.toggleArrows(standingContainerSlides, rigthArrowCont, leftArrowCont);
            
        }
    }

    toggleArrows(container, rigthArrowCont, leftArrowCont) {
        if (container.scrollLeft === 0) {
          leftArrowCont.style.display = 'none';
          container.style.marginLeft ='4.3924vw';
        } else {
          leftArrowCont.style.display = 'block';
          container.style.marginLeft = 0;
        } 
    
        if (container.scrollLeft + container.clientWidth === container.scrollWidth) {
          rigthArrowCont.style.display = 'none';
        } else {
          rigthArrowCont.style.display = 'block';
          if (container.scrollLeft > 0) {
            leftArrowCont.style.display = 'block';
          }
        }
    }
}

export default StandingsWidget;